import criteriaConfig from "@/config/criteriaConfig";
import { getSetIntersection } from "@/utils/utils";

const processCriterias = (type, state, getters) => {
    const resultObj = {};
    const lihe = state.liheData;

    const season = window.seasonManager.season === "H" ? "winter" : "summer";
    const config = criteriaConfig[season][type];

    for (const prestation of getters.prestations) {
        resultObj[parseInt(prestation.prestationId)] = [];
        const criteriaNamesIncluded = [];
        for (const configItem of config) {
            let criteriaSet;
            if (type === "advantages") {
                criteriaSet = new Set(lihe.criteriasList);
            } else {
                criteriaSet = prestation.criteriasSet;
            }
            const configSet = configItem.ids;
            const combinator = configItem.combinator;

            const setIntersection = getSetIntersection(criteriaSet, configSet);

            if (setIntersection.size === 0) continue;

            let continueFlag = false;
            configItem.conflictingCriterias.forEach((conflictingCriteria) => {
                if (criteriaNamesIncluded.includes(conflictingCriteria)) continueFlag = true;
            });
            if (continueFlag) continue;

            criteriaNamesIncluded.push(configItem.name);

            let criteriaId;
            if (combinator === "OR") {
                criteriaId = setIntersection.values().next().value;
                if (!criteriaId) continue;
            } else if (combinator === "AND") {
                if (setIntersection.size !== configSet.size) continue;
                criteriaId = configSet
                    .values()
                    .sort((a, b) => parseInt(a) - parseInt(b))
                    .join("_");
            } else {
                throw new Error("combinator mush be 'OR' or 'AND'");
            }

            const obj = {
                id: criteriaId,
                svgName: configItem.svgName,
                name: configItem.name,
                label: state.content[`criteria_${criteriaId}`],
            };

            resultObj[parseInt(prestation.prestationId)].push(obj);
        }
    }
    return resultObj;
};

export default {
    // banners_criterias: (state, getters) => {

    // },

    infoIcons_criterias: (state, getters) => {
        return processCriterias("infoIcons", state, getters);
    },

    inPrivateKitchen_criterias: (state, getters) => {
        return processCriterias("inPrivateKitchen", state, getters);
    },

    inPrivateBathroom_criterias: (state, getters) => {
        return processCriterias("inPrivateBathroom", state, getters);
    },

    inPrivateServices_criterias: (state, getters) => {
        return processCriterias("inPrivateServices", state, getters);
    },

    appartementEquipments_criterias: (state, getters) => {
        return processCriterias("appartementEquipments", state, getters);
    },
    advantages_criterias: (state, getters) => {
        return processCriterias("advantages", state, getters);
    },
};
